// recovery-repaginacao-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{dias} dias": "%{dias} días",
    "Adicionar nível": "Agregar nivel",
    "Adicionar recompensa": "Agregar recompensa",
    "Cada nível precisa de um desconto diferente: os já usados não aparecem aqui.": "Cada nivel necesita un descuento diferente: los ya usados no aparecen aquí.",
    "Cadastre um desconto tipo Recuperação em /discounts.": "Registre un descuento de tipo Recuperación en /discounts.",
    "Com SMS ligado, {{nome_do_cliente}} não pode ser usado — o SMS manda o texto cru.": "Con el SMS activado, {{nome_do_cliente}} no se puede usar — el SMS envía el texto tal cual.",
    "Editar": "Editar",
    "Falta completar": "Falta completar",
    "O cliente precisa %{quanto} de %{combustiveis} em %{postos}, %{como}. O cupom vale %{horas} h.": "El cliente necesita %{quanto} de %{combustiveis} en %{postos}, %{como}. El cupón vale %{horas} h.",
    "Quais níveis a campanha vai percorrer?": "¿Qué niveles va a recorrer la campaña?",
    "Recompensas do pacote": "Recompensas del paquete",
    "Use {{nome_do_cliente}} para o primeiro nome (só funciona no push).": "Use {{nome_do_cliente}} para el primer nombre (solo funciona en el push).",
    "abastecer": "cargar combustible",
    "abastecer %{amount} L": "cargar %{amount} L",
    "abastecer R$ %{amount}": "cargar R$ %{amount}",
    "nenhum escolhido": "ninguno elegido",
    "num abastecimento só": "en una sola carga",
    "níveis": "niveles",
    "qualquer combustível": "cualquier combustible",
    "qualquer posto da rede": "cualquier estación de la red",
    "sem título": "sin título",
    "somando vários abastecimentos": "sumando varias cargas",
};

export default catalogo;
